/**
 * Shared loading and error states for dashboard pages.
 * Sized to fit nicely inside DashboardLayout's <main> scroll area.
 */

export function PageLoading({ label = "Loading…" }) {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="flex items-center gap-2.5 text-[12px] text-text-muted">
        <Spinner />
        <span>{label}</span>
      </div>
    </div>
  );
}

export function PageError({ error, onRetry }) {
  return (
    <div className="bg-surface border border-border-default rounded-card p-8 text-center max-w-md mx-auto mt-10">
      <div className="w-10 h-10 rounded-full bg-[#fef2f2] flex items-center justify-center mx-auto mb-3">
        <span className="text-negative text-[16px] font-bold">!</span>
      </div>
      <div className="text-[13px] font-semibold text-text-primary mb-1">
        Couldn't load this page
      </div>
      <div className="text-[12px] text-text-secondary mb-4">
        {error?.message || "An unexpected error occurred."}
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="text-[12px] text-accent hover:underline font-medium"
        >
          Try again
        </button>
      )}
    </div>
  );
}

function Spinner() {
  return (
    <svg
      className="animate-spin w-4 h-4 text-accent"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="3"
      />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
